import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { ServiceInventoryService } from '@brightside-web/desktop/data-access/service-inventory';
import { ExternalPartnerService, ExternalPartnerType, PartnerDetails } from '@brightside-web/desktop/data-access/shared';
import { HomeFeedSection, registerHomeFeedCard } from '@brightside-web/desktop/feature/home-feed';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, switchMap, tap } from 'rxjs/operators';
import { ActionCardConfigInterface } from '@brightside/brightside-ui';
import { TranslateService } from '@ngx-translate/core';
import { HomeFeedService } from '@brightside-web/desktop/feature/home-feed';
import { FindMoneyHomeFeedComponent } from './find-money-home-feed/find-money-home-feed.component';

@Injectable({ providedIn: 'root' })
export class FindMoneyService extends ExternalPartnerService {
  private findMoneyDataSubject = new BehaviorSubject<PartnerDetails[]>([]);
  findMoneyData$ = this.findMoneyDataSubject.asObservable();

  constructor(
    private serviceInventory: ServiceInventoryService,
    private _translateService: TranslateService,
    private _hfService: HomeFeedService,) {
    super();

    this.serviceInventory.getService('find_money')
      .pipe(
        filter((service) => !!service),
        switchMap((service) => {
          if (service.state === 'INITIAL') {
            this.registerFindMoneyComponent();
            return this.fetchFindMoneyPartners();
          }
          return [];
        })
      )
      .subscribe();
  }

  /** Fetch Find Money partners and store in BehaviorSubject */
  private fetchFindMoneyPartners(): Observable<PartnerDetails[]> {
    this.getPartners(ExternalPartnerType.FindMoney);
    this.resetExternalPartnerDetails();

    return this.externalPartners$.pipe(
      filter((partners: PartnerDetails[] | undefined): partners is PartnerDetails[] => !!partners),
      tap((partners: PartnerDetails[]) => {
        this.findMoneyDataSubject.next(partners);
      })
    );
  }

  /** Registers a single Find Money component in Home Feed */
  private registerFindMoneyComponent() {
    this._hfService.registerHomeFeedCard({
      key: 'find-money',
      component: 'FindMoneyHomeFeedComponent',
      componentRef: FindMoneyHomeFeedComponent,
      data: null,
      order: 1,
      section: HomeFeedSection.FINDMONEY
    });
  }

  mapToCardConfig(partner: PartnerDetails): ActionCardConfigInterface {
    return {
      title: this._translateService.instant(partner.tagline || ''),
      image: `https://cdn.gobrightside.com/images/app/${partner.imagePartner}.png`,
      body: this._translateService.instant(partner.desc),
      cardStyle: 'large',
      ctaString: 'GET STARTED',
      marginBottom: 'small',
      data: partner,
    };
  }

}
